import React, { useEffect, useState } from 'react';
import NewTable from '../../components/NewTable/NewTable';

const Backups = () => {
  const [backupMode, setBackupMode] = useState('auto');
  const [timeInterval, setTimeInterval] = useState('5sec');
  const [rollbackInterval, setRollbackInterval] = useState('5sec');
  const [customTime, setCustomTime] = useState('12 days');
  const [customSelected, setCustomSelected] = useState(true);
  const [backupsData, setBackupsData] = useState([]);
  const [,setBackUpHis]=useState("")
  const dummySwapData = [
    {
      dateAndTime: "24/12/2025",
      type: "15 sec",
      download: ""
    },
    {
      dateAndTime: "24/12/2025",
      type: "15 sec",
      download: ""
    },
    {
      dateAndTime: "24/12/2025",
      type: "15 sec",
      download: ""
    },
    {
      dateAndTime: "24/12/2025",
      type: "15 sec",
      download: ""
    },
    {
      dateAndTime: "24/12/2025",
      type: "15 sec",
      download: ""
    }
  ];

  useEffect(() => {
    setBackupsData(dummySwapData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const tableHeadings = ['Date&Time', 'Type', 'Download']
  const tableRows = backupsData?.map((ele, index) => [
    ele?.dateAndTime,
    ele?.type,
    ele?.download
  ])



  return (
    <>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-[20px] font-[600] text-[#1D1F2C]">Backups</h1>
          <button className="px-4 py-2 text-[14px] font-[500] rounded-md bg-[#00811D1A] border border-[#E0E2E7]" onClick={()=>setBackUpHis()}>
            Backups History
          </button>
        </div>

        <div className="p-6 mb-4 bg-white border border-gray-200 rounded-md">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                type="radio"
                id="auto"
                name="backupMode"
                checked={backupMode === 'auto'}
                onChange={() => setBackupMode('auto')}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="auto" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">Auto</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="manual"
                name="backupMode"
                checked={backupMode === 'manual'}
                onChange={() => setBackupMode('manual')}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="manual" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">Manual</label>
            </div>
          </div>
        </div>

        <h2 className="mb-2 text-[18px] text-[#2D2D2D] font-[500]">Time</h2>
        <div className="p-6 mb-4 bg-white border border-gray-200 rounded-md">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                type="radio"
                id="5sec-time"
                name="timeInterval"
                checked={timeInterval === '5sec'}
                onChange={() => setTimeInterval('5sec')}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="5sec-time" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">5 sec</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="15sec-time"
                name="timeInterval"
                checked={timeInterval === '15sec'}
                onChange={() => setTimeInterval('15sec')}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="15sec-time" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">15 sec</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="60sec-time"
                name="timeInterval"
                checked={timeInterval === '60sec'}
                onChange={() => setTimeInterval('60sec')}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="60sec-time" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">60 sec</label>
            </div>
          </div>
        </div>

        <h2 className="mb-2 text-[18px] text-[#2D2D2D] font-[500]">Roll back</h2>
        <div className="p-6 mb-4 bg-white border border-gray-200 rounded-md">
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div className="flex items-center">
              <input
                type="radio"
                id="5sec-rollback"
                name="rollbackInterval"
                checked={rollbackInterval === '5sec' && !customSelected}
                onChange={() => {
                  setRollbackInterval('5sec');
                  setCustomSelected(false);
                }}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="5sec-rollback" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">5 sec</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="15sec-rollback"
                name="rollbackInterval"
                checked={rollbackInterval === '15sec' && !customSelected}
                onChange={() => {
                  setRollbackInterval('15sec');
                  setCustomSelected(false);
                }}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="15sec-rollback" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">15 sec</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="60sec-rollback"
                name="rollbackInterval"
                checked={rollbackInterval === '60sec' && !customSelected}
                onChange={() => {
                  setRollbackInterval('60sec');
                  setCustomSelected(false);
                }}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="60sec-rollback" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">60 sec</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="1day-rollback"
                name="rollbackInterval"
                checked={rollbackInterval === '1day' && !customSelected}
                onChange={() => {
                  setRollbackInterval('1day');
                  setCustomSelected(false);
                }}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="1day-rollback" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">1 Day</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="5days-rollback"
                name="rollbackInterval"
                checked={rollbackInterval === '5days' && !customSelected}
                onChange={() => {
                  setRollbackInterval('5days');
                  setCustomSelected(false);
                }}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="5days-rollback" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">5 Days</label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                id="2weeks-rollback"
                name="rollbackInterval"
                checked={rollbackInterval === '2weeks' && !customSelected}
                onChange={() => {
                  setRollbackInterval('2weeks');
                  setCustomSelected(false);
                }}
                className="w-4 h-4 text-black border-gray-300"
              />
              <label htmlFor="2weeks-rollback" className="ml-2 text-[#2D2D2D] text-[16px] font-[500]">2 Weeks</label>
            </div>
          </div>
        </div>


        <div className="p-6 bg-white border border-gray-200 rounded-md">
          <div className="flex items-center mb-4">
            <input
              type="radio"
              id="custom-time"
              name="rollbackInterval"
              checked={customSelected}
              onChange={() => setCustomSelected(true)}
              className="w-4 h-4 text-black border-gray-300"
            />
            <label htmlFor="custom-time" className="ml-2 text-[18px] text-[#2D2D2D] font-[500]">Select your own time</label>
          </div>

          <div className="flex items-center">
            <input
              type="text"
              value={customTime}
              onChange={(e) => setCustomTime(e.target.value)}
              className="w-48 px-3 py-2 mr-2 border border-gray-300 rounded-md"
              placeholder="Enter time period"
            />
            <button
              className="px-6 py-3 text-white bg-[#00811D] font-[500] text-[14px] rounded-md"
              onClick={() => console.log('Applied custom time:', customTime)}
            >
              Apply
            </button>
          </div>
        </div>
      </div>


      <div className='p-6'>
        <NewTable
          tableHeadings={tableHeadings}
          data={tableRows}
          showSearch={true}
          placeholder="Search by name, email..."
          showDateFilter={true}
        />
      </div>
    </>
  );
};

export default Backups;